let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3ggtd")).then(() => parcelRequire('7QhPQ'));